import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiDrop } from "@/generated/models/ApiDrop";
import ParticipationDropRatingsContainer from "./ratings/ParticipationDropRatingsContainer";
interface ParticipationDropRatingsProps {
  readonly drop: ApiDrop;
  readonly rank?: number | null | undefined;
}
export const ParticipationDropRatings: React.FC<ParticipationDropRatingsProps> = t0 => {
  const $ = _c(3);
  const {
    drop,
    rank: t1
  } = t0;
  const rank = t1 === undefined ? null : t1;
  let t2;
  if ($[0] !== drop || $[1] !== rank) {
    t2 = <ParticipationDropRatingsContainer drop={drop} rank={rank} />;
    $[0] = drop;
    $[1] = rank;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};